<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update Opportunity Field</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Client:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <ClientAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCompany"
                :searchOn="'company_or_registration_no'"
                @event-name="selectClient"
              ></ClientAutocomplete>

              {{ opportunityFieldDescription.client_id }}
            </div>
            <span class="text-danger text-sm mt-2">{{
              please_choose_client
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full" v-if="user_role=='Global Administrator'">
              <vs-input
                class="w-full"
                name="name"
                v-model="opportunityFieldDescription.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
               <div class="vx-col sm:w-1/3 w-full" v-else>
              <vs-input
                class="w-full"
                name="name"
                v-model="opportunityFieldDescription.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="opportunityFieldDescription.description"
                v-validate="'required'"
                data-vv-as="Fields Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
 
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="type"
                :options="types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="opportunityFieldDescription.type"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
            <span class="text-danger text-sm mt-2">{{
              please_choose_options
            }}</span>
          </div>
          <div
            class="vx-row mb-6"
            v-if="
              opportunityFieldDescription.type == 'dropdown' ||
                opportunityFieldDescription.type.value == 'dropdown' ||
                opportunityFieldDescription.type == 'checkbox' ||
                opportunityFieldDescription.type.value == 'checkbox' ||
                opportunityFieldDescription.type == 'choose_one' ||
                opportunityFieldDescription.type.value == 'choose_one'
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Choose Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox v-model="chooseExistingList"></vs-checkbox>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
          </div>

          <div
            class="vx-row mb-6"
            v-if="
              opportunityFieldDescription.type == 'dropdown' ||
                opportunityFieldDescription.type.value == 'dropdown' ||
                opportunityFieldDescription.type == 'checkbox' ||
                opportunityFieldDescription.type.value == 'checkbox' ||
                opportunityFieldDescription.type == 'choose_one' ||
                opportunityFieldDescription.type.value == 'choose_one'
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Value:</span>
            </div>

            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
                class="w-full"
                name="email"
                v-model="opportunityFieldDescription.value"
                data-vv-as="Value"
              />
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addValue" color="primary" type="filled"
                >Add</vs-button
              >
            </div>
          </div>
          <div class="vx-row mb-6" v-if="chooseExistingList">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-row vs-w="12" class="mb-5">
                <vs-col vs-lg="8" vs-sm="8" vs-xs="12"
                  >
                     <FieldsAutocomplete
                    :key="companySearchComponentKey"
                    class="searchbox"
                    :list="searchExistingFieldLists"
                    :searchOn="'opportunity-field'"
                    @event-name="handleChildEvent"
                  ></FieldsAutocomplete>
                  
                  <!-- <v-select
                    class="mb-4"
                    label="name"
                    name="existing_list"
                    :options="existing_fields_list"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="fields.existing_list"
                  /> -->
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="4"
                  vs-sm="4"
                  vs-xs="12"
                >
                </vs-col>
              </vs-row>

              <div class="vx-col sm:w-1/2 w-full">
                <span v-for="elv in existing_list_values" class="p-2">
                  <vs-input
                    class="w-full"
                    name="existing_list_value"
                    v-model="elv.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeExistingListValues(elv)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </div>
            </div>
          </div>

          <div
            class="vx-row mb-6"
            v-if="
              opportunityFieldDescription.type == 'dropdown' ||
                opportunityFieldDescription.type.value == 'dropdown' ||
                opportunityFieldDescription.type == 'checkbox' ||
                opportunityFieldDescription.type.value == 'checkbox' ||
                opportunityFieldDescription.type == 'choose_one' ||
                opportunityFieldDescription.type.value == 'choose_one'
            "
          >
            <template>
              <div class="vx-col sm:w-1/5 w-full"></div>
            </template>

            <div
              class="vx-col sm:w-1/4 w-full"
              v-if="opportunityFieldDescription.values"
            >
              <template v-for="(v, index) in opportunityFieldDescription.values">
                <span :key="index" class="p-2">
                  <vs-input
                    class="w-full"
                    name="field_new_values"
                    v-model="v.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeSelectedValue(v)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </template>
            </div>
          </div>

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <DataGrid :context="'opportunityField'" 
            ref="opportunityFields"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import FieldsAutocomplete from "@/components/autocomplete/FieldsAutocomplete.vue";
import moduleMasterFieldsManagement from "@/store/fields-management/master-fields-management/moduleMasterFieldsManagement.js";
import moduleOpportunityFieldsManagement from "@/store/fields-management/opportunity-fields-management/moduleOpportunityFieldsManagement.js";
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
            selected_client: null,

      companySearchComponentKey: 0,
      please_choose_client:null,
      please_choose_options: null,
      opportunityFieldDescription: [],
      fieldId: null,
      chooseExistingList: false,
      columnDefs: [
        {
        headerName: "Client",
        field: "company_name",
        width: 400,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
      },
        {
          headerName: "Name",
          field: "name",
          width: 400,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          field: "description",
          width: 400,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
         {
        headerName: "Level",
        field: "level",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
        {
          headerName: "Type",
          field: "type",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Value",
          field: "values",
          width: 550,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Sales Developer Access",
          field: "sales_developer_access",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      user_role:null,
      dataSource: {},
      records: [],
      selected: [],
      allFields: [],
      abilities: null,
      existing_list_values: null,
      existing_fields_list: [],
      fields: {
        values: [],
        name: null,
        description: null,
        type: null,
        level:'account',
        value: null,
        sales_developer_access: "yes",
        existing_list: null
      },
      types: [
        {
          name: "Text",
          value: "text"
        },
        {
          name: "Number",
          value: "number"
        },
        {
          name: "Textarea",
          value: "textarea"
        },
        {
          name: "Date",
          value: "date"
        },
        {
          name: "DateTime",
          value: "datetime"
        },
        {
          name: "Checkbox",
          value: "checkbox"
        },
        {
          name: "Dropdown",
          value: "dropdown"
        },
        {
          name: "Choose One",
          value: "choose_one"
        },
        {
          name: "Client Contact",
          value: "client_contact"
        }
      ]
    };
  },
  components: {
    "v-select": vSelect,
    moduleOpportunityFieldsManagement,
    DataGrid,
    FieldsAutocomplete,
    ClientAutocomplete
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleOpportunityFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "OpportunityFieldsManagement",
        moduleOpportunityFieldsManagement
      );
      moduleOpportunityFieldsManagement.isRegistered = true;
    }

    if (!moduleMasterFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "MasterFieldsManagement",
        moduleMasterFieldsManagement
      );
      moduleMasterFieldsManagement.isRegistered = true;
    }

    if (!moduleClientsManagement.isRegistered) {
      self.$store.registerModule("clientsManagement", moduleClientsManagement);
      moduleClientsManagement.isRegistered = true;
    }

    if (!moduleOpportunitiesManagement.isRegistered) {
      self.$store.registerModule("opportunitiesManagement", moduleOpportunitiesManagement);
      moduleOpportunitiesManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fieldId = this.$route.params.fieldId;
    this.fetchOpportunityField();
    this.getExistingFieldLists();
  },
  watch: {
    "opportunityFieldDescription.type.value": function(val) {
      if (val) {
        this.please_choose_options = null;
      }
    },
    // "fields.existing_list": function(val) {
    //   if (val) {
    //     let filtered_value = this.existing_fields_list.filter(ele => {
    //       return ele.field_id == val.field_id;
    //     });
    //     if (filtered_value) {
    //       let lists = filtered_value[0];
    //       this.existing_list_values = JSON.parse(lists.values);
    //     }

    //     console.log(this.existing_list_values);
    //   }
    // },
    chooseExistingList: function(val) {
      if (val) {
        this.chooseExistingList = true;
        // this.existing_list_values = null
        // // let filtered_value = this.existing_fields_list.filter(ele => {
        // //   return ele.field_id == val.field_id;
        // // });
        // let filtered_value = this.existing_fields_list
        // if (filtered_value) {
        //   let lists = filtered_value[0];
        //   this.existing_list_values = JSON.parse(lists.values);
        // }

        // console.log(this.existing_list_values);
      } else {
        this.existing_list_values = [];
      }
    },
    "opportunityFieldDescription.type": function(val) {
      // if(this.opportunityFieldDescription.type == val){
      //   this.opportunityFieldDescription.type.value == val
      // }
      // alert(val)
    }
  },
  methods: {
    selectClient() {
      let self = this;
      let clients = moduleClientsManagement.state.clients.datas;
      if (clients) {
        this.selected_client = clients[0];
      }
    },
    searchCompany(inputValue) {
      this.please_choose_client = null;
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data = moduleClientsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
     searchExistingFieldLists(inputValue) {
      let search_from = "opportunity_field";
      return this.$store
        .dispatch("MasterFieldsManagement/searchExistingFieldLists", {
          search_from: search_from,
          inputValue: inputValue
        })
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              data = JSON.parse(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].field_id,
                  name: data[property].name
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleChildEvent() {
      let selected_field = moduleOpportunityFieldsManagement.state.selected_fields;

        console.log("EXis" , this.existing_fields_list)


      if (selected_field) {
        let filtered_value = this.existing_fields_list.filter(ele => {
          return ele.field_id == selected_field.id;
        });
 

        console.log("Filtered" , filtered_value)



        if (filtered_value) {
          let lists = filtered_value[0];
          this.existing_list_values = JSON.parse(lists.values);
        }

        console.log(this.existing_list_values);
      }
    },
    removeSelectedValue(value) {
      this.opportunityFieldDescription.values = this.opportunityFieldDescription.values.filter(
        item => {
          return item != value;
        }
      );
    },
    removeExistingListValues(value) {
      this.existing_list_values = this.existing_list_values.filter(item => {
        return item != value;
      });
    },
    addValue() {
      if (this.opportunityFieldDescription.values == null) {
        this.opportunityFieldDescription.values = [];
      }

      if (
        this.opportunityFieldDescription.value &&
        !this.opportunityFieldDescription.values.includes(
          this.opportunityFieldDescription.value
        )
      )
        this.opportunityFieldDescription.values.push({
          value: this.opportunityFieldDescription.value
        });
      this.opportunityFieldDescription.value = null;
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "OpportunityFieldsManagement/getAllOpportunityFields",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.opportunityFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.opportunityFields.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateFields();
        }
      });
    },
    updateFields() {
      if (this.opportunityFieldDescription.values == null) {
        this.opportunityFieldDescription.values = [];
      }

      if (this.existing_list_values == null) {
        this.existing_list_values = [];
      }
      

      if (
        this.opportunityFieldDescription.type.value == "checkbox" ||
        this.opportunityFieldDescription.type == "checkbox" ||
        this.opportunityFieldDescription.type.value == "dropdown" ||
        this.opportunityFieldDescription.type == "dropdown" ||
        this.opportunityFieldDescription.type.value == "choose_one" ||
        this.opportunityFieldDescription.type == "choose_one"
      ) {
        if (
          this.opportunityFieldDescription.values.length == 0 &&
          this.existing_list_values.length == 0
        ) {
          this.please_choose_options =
            "Atleast one options is required for " +
            this.opportunityFieldDescription.type.value +
            " list.";
          return false;
        }
      }


          if (
        typeof this.selected_client !== "undefined" &&
        this.selected_client !== null
      ) {        this.opportunityFieldDescription.selected_client_id = this.selected_client.id;
      } else {
              if(this.opportunityFieldDescription.selected_client_id == null){

        this.please_choose_client = "Please select the client.";
        return false;
      }

      }

    
 


      let joined_values = [];
      joined_values = this.opportunityFieldDescription.values.concat(
        this.existing_list_values
      );
      joined_values = joined_values.filter(function(ele) {
        return ele != null;
      });
      this.opportunityFieldDescription.values = joined_values;

      if (typeof this.opportunityFieldDescription.type === "object") {
        this.opportunityFieldDescription.type = this.opportunityFieldDescription.type.value;
      }

      if (
        this.opportunityFieldDescription.type == "text" ||
        this.opportunityFieldDescription.type == "number" ||
        this.opportunityFieldDescription.type == "textarea" ||
        this.opportunityFieldDescription.type == "date"
      ) {
        this.opportunityFieldDescription.values = null;
      }

      this.$store
        .dispatch(
          "OpportunityFieldsManagement/updateFields",
          this.opportunityFieldDescription
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Opportunity Fields Exists",
              text: res.data.message
            });
                        var uniq = {}
            this.campaignFieldDescription.values = this.campaignFieldDescription.values.filter(obj => !uniq[obj.value] && (uniq[obj.value] = true));
            console.log(this.fields.values)
          } else {
            this.$vs.notify({
              color: "success",
              title: "Field Updated",
              text: "The opportunity fields was updated successfully"
            });
            this.$router.push({ path: "/fields/opportunity-fields" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchOpportunityField() {
      this.$store
        .dispatch("OpportunityFieldsManagement/fetchFields", this.fieldId)
        .then(res => {
          let result = JSON.parse(res.data);
          this.opportunityFieldDescription = result[0];
       

          if(this.opportunityFieldDescription.opportunity_id){
            this.opportunityFieldDescription.selected_client_id = this.opportunityFieldDescription.opportunity_id
          }

          this.opportunityFieldDescription.values = JSON.parse(
            this.opportunityFieldDescription.values
          );
        })
        .catch(err => {
          console.error(err);
        });
    },
    getExistingFieldLists() {
      this.$store
        .dispatch(
          "OpportunityFieldsManagement/getExistingFieldLists",
          "opportunity_field"
        )
        .then(res => {
          console.log("LISTS", JSON.parse(res.data));
          let result = JSON.parse(res.data);
          if (result) {
            this.existing_fields_list = result;
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
